import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import '../../../sheet/bottom-sheet/index.esm.js';
import '../../../sheet/popover-sheet/index.esm.js';
import '../../../sheet/side-sheet/index.esm.js';
import '../../../sheet/centered-sheet/index.esm.js';
import '../../../sheet/full-sheet/index.esm.js';
import { EGDSSheet } from '../../../sheet/sheet/index.esm.js';
import { EGDSSheetContent } from '../../../sheet/sheet-content/index.esm.js';
import '../../../sheet/sheet-close-button/index.esm.js';
import { EGDSSheetTransition } from '../../../sheet/sheet-transition/index.esm.js';
import '../../../sheet/sheet-footer/index.esm.js';
import '../../../sheet/types/index.esm.js';
import '../../../spacing/types/index.esm.js';
import { EGDSSpacing } from '../../../spacing/spacing/index.esm.js';
import '../../../spacing/spacing-hr/index.esm.js';
import '../../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../../layout-flex/layout-flex-item/index.esm.js';
import '../../../button/button/index.esm.js';
import { EGDSPrimaryButton } from '../../../button/primary-button/index.esm.js';
import { EGDSTertiaryButton } from '../../../button/tertiary-button/index.esm.js';
import '../../../button/paging-button/index.esm.js';
import '../../../toolbar/toolbar/index.esm.js';
import { EGDSToolbar } from '../../../toolbar/egds-toolbar/index.esm.js';
import '../../../toolbar/toolbar-container/index.esm.js';
import '../../../toolbar/transparent-toolbar/index.esm.js';
import '../../../toolbar/toolbar-button/index.esm.js';
import styles from '../../../styles/uitk-egds-date-selector.css';
import { EGDSAlert } from '../../alert/index.esm.js';
import { classNames } from '../../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const dateSelectorPopoverClassName = 'uitk-date-selector-popover';
const PopoverCalendar = props => {
  const {
    autoPosition,
    isOpen,
    triggerRef,
    children,
    ctaItems,
    dateSelectorPlayback,
    hideFooter,
    isSingleMonth,
    showPlayback,
    showOffset,
    calendarWrapper,
    alertTemplateComponent,
    alertTemplateData,
    popoverWidth,
    initialOpenState
  } = props;
  const {
    submitCta,
    clearDatesCta
  } = ctaItems;
  const CalendarWrapper = React.useMemo(() => calendarWrapper ? calendarWrapper.component : React.Fragment, [calendarWrapper]);
  const dateSelectorPopoverClasses = getClassNameList(dateSelectorPopoverClassName, {
    'uitk-date-selector-popover-single': isSingleMonth
  });
  // Focus should happen only when the component is open/close via user interactions (trigger and close button)
  const [shouldFocus, setShouldFocus] = React.useState(!initialOpenState);
  const toggleCallback = () => {
    if (!shouldFocus) {
      setShouldFocus(true);
    }
  };
  return jsx(EGDSSheetTransition, {
    isVisible: isOpen,
    openCallback: toggleCallback,
    children: jsxs(EGDSSheet, {
      isVisible: isOpen,
      type: "popover",
      triggerRef: triggerRef,
      onDismiss: ctaItems.closeCta.handler,
      className: getClassNameList(dateSelectorPopoverClasses),
      returnFocusOnClose: shouldFocus,
      showOverTrigger: !showOffset,
      applyBlockStartMargin: !!showOffset,
      disableArrowKeyHandler: true,
      width: popoverWidth,
      autoFocus: shouldFocus,
      autoPosition: autoPosition,
      children: [jsxs(CalendarWrapper, {
        ...calendarWrapper?.props,
        children: [showPlayback && jsx(EGDSToolbar, {
          childClassName: getClassNameList('uitk-date-selector-playback-toolbar'),
          children: dateSelectorPlayback
        }), jsx(EGDSSheetContent, {
          padded: false,
          className: getClassNameList(`${dateSelectorPopoverClassName}-content`),
          children: children
        })]
      }), alertTemplateComponent && jsx(EGDSAlert, {
        alertTemplateComponent: alertTemplateComponent,
        alertTemplateData: alertTemplateData
      }), !hideFooter && jsx(EGDSSpacing, {
        padding: {
          inline: 'two',
          block: 'three'
        },
        children: jsx("footer", {
          className: getClassNameList('uitk-sheet-footer'),
          children: jsxs(EGDSLayoutFlex, {
            space: "three",
            justifyContent: "end",
            children: [clearDatesCta.handler && jsx(EGDSLayoutFlexItem, {
              children: jsx(EGDSTertiaryButton, {
                onClick: clearDatesCta.handler,
                "aria-disabled": clearDatesCta.disabled,
                tabIndex: clearDatesCta.disabled ? -1 : 0,
                children: clearDatesCta.label
              })
            }), submitCta.handler && jsx(EGDSLayoutFlexItem, {
              children: jsx(EGDSPrimaryButton, {
                "data-stid": "apply-date-selector",
                disabled: submitCta.disabled,
                onClick: submitCta.handler,
                children: submitCta.label
              })
            })]
          })
        })
      })]
    })
  });
};
export { PopoverCalendar };